import { jsx } from 'react/jsx-runtime';
import { useComposedRefs } from '@radix-ui/react-compose-refs';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDropdownContext } from '../../contexts/context.mjs';
import { dropdownFixedArea } from '../../shared/styles/fixedArea.vanilla.mjs';

const DropdownContentAffix = forwardRef(({ className: classNameFromProps, ...props }, forwardedRef) => {
  const { onContentAffixElementChange } = useDropdownContext("ContentAffix");
  const className = classNames(
    dropdownFixedArea({ side: "top" }),
    classNameFromProps
  );
  const composedRef = useComposedRefs(
    forwardedRef,
    (element) => onContentAffixElementChange(element)
  );
  return /* @__PURE__ */ jsx(
    Primitive.div,
    {
      "data-scope": "dropdown",
      "data-part": "content-affix",
      className,
      ref: composedRef,
      ...props
    }
  );
});

export { DropdownContentAffix };
//# sourceMappingURL=ContentAffix.mjs.map
